import { Component, Input } from '@angular/core';

// Мастер ввода анкеты форма-2018 для сайта и моб. приложения
@Component({
    selector: 'features2-mobile',
    templateUrl: './features2.mobile.component.html',
    styleUrls: ['./features2.mobile.component.scss']
})
export class Features2MobileComponent {
    @Input() model: any;
    @Input() sheet: boolean = false;
}
